import dynamic from 'next/dynamic';

export const CommentSection = dynamic(() => import('./CommentSection'));
export const ContentDetailSection = dynamic(
  () => import('./ContentDetailSection'),
);
export const RightSideBar = dynamic(() => import('./RightSideBar'));
export const WrapperPostForUser = dynamic(() => import('./WrapperPostForUser'));
export const ReadMoreSection = dynamic(() => import('./ReadMoreSection'));
export const RelatedCategory = dynamic(() => import('./RelatedCategory'));
